import { LoadingButton } from '@mui/lab';
import { FormControlLabel, Grid, MenuItem, Paper, Switch, TextField, Typography } from '@mui/material';
import FieldLabel from '../../../../../Components/FieldLabel';
import { FEATURE_DESCRIPTION } from '../../../constant';
import { COMPOSITION_ID_OPTIONS, LANGUAGE_OPTIONS } from './constants';

const { RSS_INFO_MESSAGES } = FEATURE_DESCRIPTION.VIDEO_CONTENT;

const ManualJobCard = ({ jobForm, loading, onChange, onCreate, isFeatureEnabled, isExperimentalUser }) => {
	return (
		<Paper variant="outlined" sx={{ p: 3, height: '100%' }}>
			<Typography variant="h6" fontWeight={700}>
				Manual Video Generation
			</Typography>
			<Typography variant="body2" color="text.secondary" sx={{ mt: 1, mb: 3 }}>
				Queue a single article URL for video generation.
			</Typography>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<TextField
						fullWidth
						label="Page URL (include trailing slash)"
						value={jobForm.pageURL}
						onChange={(e) => onChange('pageURL', e.target.value)}
						disabled={!isFeatureEnabled}
					/>
				</Grid>
				<Grid item xs={12} sm={6}>
					<FieldLabel infoMessage={RSS_INFO_MESSAGES.LANGUAGE}>
						Language
					</FieldLabel>
					<TextField
						fullWidth
						select
						value={jobForm.language}
						onChange={(e) => onChange('language', e.target.value)}
						disabled={!isFeatureEnabled}
					>
						{LANGUAGE_OPTIONS.map((language) => (
							<MenuItem key={language.value} value={language.value}>
								{language.label}
							</MenuItem>
						))}
					</TextField>
				</Grid>
				{isExperimentalUser && (
					<Grid item xs={12} sm={6}>
						<FieldLabel infoMessage={RSS_INFO_MESSAGES.VIDEO_TEMPLATE}>
							Video Template
						</FieldLabel>
						<TextField
							fullWidth
							select
							value={jobForm.compositionId}
							onChange={(e) => onChange('compositionId', e.target.value)}
							disabled={!isFeatureEnabled}
						>
							{COMPOSITION_ID_OPTIONS.map((composition) => (
								<MenuItem key={composition.value} value={composition.value}>
									{composition.label}
								</MenuItem>
							))}
						</TextField>
					</Grid>
				)}
				{isExperimentalUser && (
					<Grid item xs={12} sm={6}>
						<FormControlLabel
							control={
								<Switch
									checked={jobForm.debug}
									onChange={(e) => onChange('debug', e.target.checked)}
									disabled={!isFeatureEnabled}
								/>
							}
							label="Debug Mode"
						/>
					</Grid>
				)}
			</Grid>

			<LoadingButton
				variant="contained"
				sx={{ mt: 3 }}
				onClick={onCreate}
				loading={loading.createJob}
				disabled={!isFeatureEnabled || !jobForm.pageURL}
			>
				Create Job
			</LoadingButton>
		</Paper>
	);
};

export default ManualJobCard;
